export default __webpack_public_path__ + "static/media/logo-humano-seguro-azul.bfdec32f.jpg";